export default [
  {
    path: "log/plan-out-of-stock",
    name: "PlanOutOfStock",
    component: () => import("@/pages/log/PlanOutOfStock.vue"),
    meta: {
      title: "计划断货日志",
      requireAuth: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/log.js